<template>
  <div class="field no-select">
    <label
      v-if="label"
      class="mb-2 label no-select"
      :for="name"
    >
      <h3>
        {{ label }}
      </h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <div class="dropdown">
      <textarea
        :id="name"
        ref="dropdowninput"
        v-model.trim="inputValue"
        class="dropdown-input"
        type="text"
        placeholder="Digite um endereço"
        :disabled="isDisabled"
        @keyup="searchGeo"
      ></textarea>
      <div
        v-show="showAddressList"
        class="dropdown-list"
      >
        <div
          v-for="(item, index) in resolvedOptions"
          v-show="itemVisible(item)"
          :key="index"
          class="dropdown-item"
          @click="selectItem(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LegacyGoogleProvider } from 'leaflet-geosearch';

import commonProperties from './common-properties';

export default {
  name: 'SelectGeo',
  mixins: [commonProperties],
  inheritAttrs: false,
  data() {
    return {
      resolvedOptions: [
        {
          label: 'Carregando...',
        },
      ],
      selectedItem: {},
      inputValue: '',
      itemList: [],
      provider: new LegacyGoogleProvider({
        params: {
          key: 'AIzaSyCGtQXHJAMo4cqtOXHxvc3alBXKgbzCOt8',
        },
      }),
      selectedValue: '',
      enableSearch: false,
    };
  },
  computed: {
    showAddressList() {
      return this.inputValue && this.enableSearch;
    },
  },
  watch: {
    selectedItem() {
      this.model = this.selectedItem;
    },
    inputValue(val) {
      if (this.model) {
        this.enableSearch = this.model.label !== val;
      } else {
        this.enableSearch = true;
      }
    },
    model(val) {
      this.inputValue = val !== undefined ? val.label : '';
    },
  },
  mounted() {
    this.inputValue = this.model !== undefined ? this.model.label : '';
  },
  methods: {
    resetSelection() {
      this.selectedItem = {};
      this.$nextTick(() => this.$refs.dropdowninput.focus());
      this.$emit('on-item-reset');
    },
    selectItem(theItem) {
      this.enableSearch = false;
      this.selectedItem = theItem;
      this.selectedItem.label = this.simplifyingAddress(
        this.selectedItem.label,
      );
      this.inputValue = this.selectedItem.label;
      this.$emit('on-item-selected', theItem);
    },
    itemVisible(item) {
      return Object.keys(item).length > 0;
    },
    searchGeo() {
      try {
        if (this.inputValue.length > 0) {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.resolvedOptions = await this.provider.search({
              query: this.inputValue,
            });
          }, 1000);
        }
      } catch (err) {
        console.log('Ocorreu um erro na busca');
      }
    },
    simplifyingAddress(address) {
      const result = address.split(',', 2);
      return result[1] ? result[0] + result[1] : result[0];
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}

.dropdown {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.dropdown-input {
  width: 100%;
  line-height: 1.5em;
  outline: none;
  display: block;
  background-color: $lighter;
  font-size: $size-small;
  color: $darker;
  border: 1px solid $light;
  border-radius: 4px;
  padding: 10px 16px;
}

.dropdown-input:focus {
  border-color: $crm-blue-primary;
}

.dropdown-input::placeholder {
  color: $light;
  font-size: $size-smaller;
}

.dropdown-selected {
  font-weight: bold;
  cursor: pointer;
}

.dropdown-list {
  height: auto;
  width: 100%;
  background: $lb-white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 0 0 4px 4px;
}

.dropdown-item {
  display: flex;
  width: 100%;
  padding: 11px 16px;
  cursor: pointer;
  white-space: initial;

  &:hover {
    background: #edf2f7;
  }
}

.dropdown-item-flag {
  max-width: 24px;
  max-height: 18px;
  margin: auto 12px auto 0px;
}

.field {
  height: auto;
}
</style>
